import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AdminEducatorCenter from "../AdminEducatorCenter";
import AdminEducatorCenterV2 from "../AdminEducatorCenterV2";
import ProgressReportSetup from "../ProgressReportSetup";
import AcademicSetup from "../AcademicSetup";
import MYPAcademicSetup from "../MYPAcademicSetup";
import UBDAcademicSetup from "../UBDAcademicSetup";
import PlanningInsights from "PlanningInsights";
import SnP_v2 from "../SnP_v2";
import SnP from "../SnP";
import DPAcademicSetup from "../DPAcademicSetup";
import ProjectGroupSetup from "../ProjectGroupSetup";
import AttendanceDashboard from "../AttendanceDashboard";
import { ExamRegistration } from "../DPExamRegistration";
import Settings from "../Settings";
import YearGroup from "../YearGroup";
import { ECoursework } from "../IB_ECoursework";
import Timetable from "../Timetable";
import AttendanceAndTimetableSettings from "../AttendanceAndTimetableSettings";
import RosterDataToNextAcademicYear from "../RosterDataToNextAcademicYear";
import QuestionBank from "../QuestionBank";
import Trash from "../Trash";
import AdminGradebook from "../AdminGradebook";
import NotificationsManager from "../NotificationsManager";
import TimetableManagerV2 from "../TimetableManagerV2";
import IBISRegistration from "../IBISRegistration";

export default store => ({
  path: ":curriculumProgramId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-curriculum-type" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Trash(store),
    AdminEducatorCenter(store),
    AdminEducatorCenterV2(store),
    ProgressReportSetup(store),
    PlanningInsights(store),
    AcademicSetup(store),
    MYPAcademicSetup(store),
    UBDAcademicSetup(store),
    ProjectGroupSetup(store),
    DPAcademicSetup(store),
    AttendanceDashboard(store),
    Settings(store),
    SnP_v2(store),
    SnP(store),
    YearGroup(store),
    Timetable(store),
    AttendanceAndTimetableSettings(store),
    TimetableManagerV2(store),
    RosterDataToNextAcademicYear(store),
    QuestionBank(store),
    AdminGradebook(store),
    NotificationsManager(store),
    ..._.map(ExamRegistration, comp => comp(store)),
    ..._.map(ECoursework, comp => comp(store)),
    IBISRegistration(store),
  ],
});
